module.exports = require("./runtime/vdom");
